import React from "react";
import styled from "styled-components";
import { color } from "@8x8/oxygen-constants";

const Container = styled.div`
  text-align: center;
  &:nth-child(n + 2) {
    border-left: 1px dotted ${color.cloudyBlue900};
    margin-left: 16px;
    margin-right: 16px;
  }
`;

export const HorizontalColumn = (props) => {
  return <Container>{props.children}</Container>;
};
